var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-center",class:_vm.classes},[_c('p',[_c('span',[_vm._v("©")]),_c('span',[_vm._v(_vm._s(new Date().getFullYear())+" ")]),_vm._v("\n      Trust Effort\n      "),_c('span',{staticClass:"hidden sm:inline-block"},[_vm._v(", All rights Reserved")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }